// extracted by mini-css-extract-plugin
export var active = "_e5-2";
export var recordingDot = "_e5-1";
export var recordingIndicator = "_e5-0";